export default __webpack_public_path__ + "static/media/G4.20613ad7.mp3";